import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import App from './App';
import * as serviceWorker from './serviceWorker';
import firebaseConfig from './firebase-config';
import {
  FirebaseAppProvider
} from 'reactfire';
//import './App.css';
import './assets/scss/style.scss';

const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    
      <FirebaseAppProvider firebaseConfig={firebaseConfig}>
        <Suspense fallback={'Cargando datos...'}>
          <App />
        </Suspense>
       
      </FirebaseAppProvider>
      
    
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
